import { makeStyles } from "@material-ui/styles";
import * as React from "react";
import { IOptionsContent, QuestionType } from "src/common/types";
import { mapOptionsToRangeLabels } from "src/helpers";
import { ScaleQuestion } from "../Questions/ScaleQuestion";

const useStyles = makeStyles({
  container: {
    margin: "0 -24px",
    position: "relative" as "relative"
  }
});

interface IProps {
  content: IOptionsContent;
  value: number;
  type: QuestionType.TextScale | QuestionType.NumericScale | QuestionType.Scale;
}

const ScaleResponse = ({ content, value, type }: IProps) => {
  const labels = React.useMemo(() => {
    return mapOptionsToRangeLabels(content.options);
  }, [content]);
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <ScaleQuestion
        type={type}
        max={content.options.length - 1}
        min={0}
        step={0.25}
        labels={labels}
        value={value}
        preview
      />
    </div>
  );
};

export default React.memo(ScaleResponse);
